import { memo } from 'react';
import PropTypes from 'prop-types';
import {
  FaCheck, FaTimes,
} from 'react-icons/fa';
import InfoIcon from '@material-ui/icons/Info';
import Label from '../../../Label';
import { RefundTypes } from '../../../../constants';

const HotelCancellationLabel = ({ product }) => {
  if (!product) return <></>;
  const getLabelText = () => {
    if (product.refundType === RefundTypes.FullyRefundable) return 'Refundable';
    if (product.refundType === RefundTypes.PartialRefundable) return 'Refundable (penalty applies)';
    return 'Non-Refundable';
  };

  return (
    <Label
      text={(
        <span>
          {getLabelText()}
          <InfoIcon className="-mt-1 ml-1" style={{ fontSize: '1.25rem' }} />
        </span>
        )}
      icon={product.nonRefundable ? <FaTimes /> : <FaCheck />}
      level={product.nonRefundable ? 'danger' : 'success'}
      italic
      inline
      descriptionOnHover={`${product.cancellationPolicy}${product.cancellationPenaltyDescription ? `<br/><b>Penalty description: </b>${product.cancellationPenaltyDescription}` : ''}`}
    />
  );
};

HotelCancellationLabel.propTypes = {
  product: PropTypes.shape({
    nonRefundable: PropTypes.bool,
    refundType: PropTypes.number,
    cancellationPolicy: PropTypes.string,
    cancellationPenaltyDescription: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
};

export default memo(HotelCancellationLabel);
